// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3QxKo","text":"SelectPayment_text__1KYuj","title":"SelectPayment_title__na85Z","btn":"SelectPayment_btn__3XVMS"};